import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SLUGS } from '../../stops';

@Injectable({
  providedIn: 'root'
})
export class ValidateTourStopGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const isSpanish =
      state.url.slice(0, 4) == '/es' || state.url.slice(0, 4) == '/es/';
    const stopUrl = isSpanish ? state.url.slice(4) : state.url.slice(1);
    const stopSlug =
      stopUrl.slice(-5) == '/info' ? stopUrl.slice(0, -5) : stopUrl;
    // const cur_slug = router.url.slice(1);
    // const cur_stop_name = router.url.includes('info') ? router.url.slice(1, -5) : cur_slug;
    console.log('stopSlug', stopSlug, SLUGS, SLUGS.includes(stopSlug));

    if (!SLUGS.includes(stopSlug)) {
      // this.router.navigate([isSpanish ? 'es' : '', SLUGS[0]]);
      this.router.navigate(['']);
      return false;
    }

    return true;
  }
}
